import { render, staticRenderFns } from "./RealtimeNotificationPopup.vue?vue&type=template&id=6119add8&scoped=true"
import script from "./RealtimeNotificationPopup.vue?vue&type=script&lang=js"
export * from "./RealtimeNotificationPopup.vue?vue&type=script&lang=js"
import style0 from "./RealtimeNotificationPopup.vue?vue&type=style&index=0&id=6119add8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6119add8",
  null
  
)

export default component.exports